module.exports = __webpack_public_path__ + "img/Syngamus.e0492db4.png";